import { makeActionCreator } from '../../config/store/utils'
import { getAccumulatedAmount, getAccumulatedAmountDetail } from '../../services/expenses'

export const GET_ACCUMULATED_AMOUNT = 'GET_ACCUMULATED_AMOUNT'
export const GET_ACCUMULATED_AMOUNT_ERROR = 'GET_ACCUMULATED_AMOUNT_ERROR'
export const GET_ACCUMULATED_AMOUNT_SUCCESS = 'GET_ACCUMULATED_AMOUNT_SUCCESS'
export const onAccumulatedAmount = makeActionCreator(GET_ACCUMULATED_AMOUNT)
export const onAccumulatedAmountError = makeActionCreator(GET_ACCUMULATED_AMOUNT_ERROR, 'payload')
export const onAccumulatedAmountSuccess = makeActionCreator(GET_ACCUMULATED_AMOUNT_SUCCESS, 'payload')
export const onAccumulatedAmountThunk = () => async dispatch => {
  dispatch(onAccumulatedAmount())

  try {
    const { data } = await getAccumulatedAmount({ actionType: GET_ACCUMULATED_AMOUNT })

    return dispatch(onAccumulatedAmountSuccess({ accumulatedAmount: data?.payload }))
  } catch (error) {
    return dispatch(onAccumulatedAmountError({ error }))
  }
}

export const GET_ACCUMULATED_AMOUNT_DETAIL = 'GET_ACCUMULATED_AMOUNT_DETAIL'
export const GET_ACCUMULATED_AMOUNT_DETAIL_ERROR = 'GET_ACCUMULATED_AMOUNT_DETAIL_ERROR'
export const GET_ACCUMULATED_AMOUNT_DETAIL_SUCCESS = 'GET_ACCUMULATED_AMOUNT_DETAIL_SUCCESS'
export const onAccumulatedAmountDetail = makeActionCreator(GET_ACCUMULATED_AMOUNT_DETAIL)
export const onAccumulatedAmountDetailError = makeActionCreator(GET_ACCUMULATED_AMOUNT_DETAIL_ERROR, 'payload')
export const onAccumulatedAmountDetailSuccess = makeActionCreator(GET_ACCUMULATED_AMOUNT_DETAIL_SUCCESS, 'payload')
export const onAccumulatedAmountDetailThunk = payload => async dispatch => {
  dispatch(onAccumulatedAmountDetail())

  try {
    const { data } = await getAccumulatedAmountDetail({ year: payload.year })

    const accumulatedAmountDetail = {
      year: payload.year,
      data: data?.payload.map(item => ({
        amountCLP: item.amountMonthCLP,
        amountUSD: item.amountMonthUSD,
        month: item.month,
        qtyOC: item.qtyOC
      }))
    }

    return dispatch(onAccumulatedAmountDetailSuccess({ accumulatedAmountDetail }))
  } catch (error) {
    return dispatch(onAccumulatedAmountDetailError({ error }))
  }
}

export const SET_CUMULATIVE_AMOUNT_YEAR_SUCCESS = 'SET_CUMULATIVE_AMOUNT_YEAR_SUCCESS'
export const setCumulativeAmountYearSuccess = makeActionCreator(SET_CUMULATIVE_AMOUNT_YEAR_SUCCESS, 'payload')
